import {faqComponentJS} from "./component/faq/faq-common";

faqComponentJS.init();
